import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [{
    path: '/h5Map',
    name: 'h5MapPage',
    component: () => import( /* webpackChunkName: "h5地图" */ '@/page/h5Map'),
    meta: {
      // 是否免密登录
      isToken: true
    },
  },{
    path: '/info',
    name: 'info',
    component: () => import( /* webpackChunkName: "默认地址" */ '@/page/info'),
    meta: {
      // 是否免密登录
      isToken: true
    },
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js